export default __webpack_public_path__ + "static/john-7d41fba72b06bd9240b3973651fe2f7b.png";